import React, { useEffect, useRef } from 'react'

import { Link } from '@paypalcorp/pp-react'
import styles from './AiSearch.module.css'

/* Note: As the react mardown package is ESM only. using require to import the module 
https://github.com/remarkjs/react-markdown#install
*/
const Markdown = require('react-markdown').default

interface MarkdownContainerProps {
  setCollapseSeeMore: () => void
  setSummaryContainerHeight: () => void
  setSummaryTextHeight: () => void
  answerId: string
  searchID: string
  collapseSeeMore: boolean
  answerSummary: string
}

const MarkdownContainer = ({
  answerId,
  searchID,
  collapseSeeMore,
  answerSummary,
  setSummaryContainerHeight,
  setSummaryTextHeight,
}): MarkdownContainerProps => {
  const fptiData = typeof window !== `undefined` && window.fpti

  const summaryTextRef = useRef(null)
  const summaryContainerHeightRef = useRef(null)

  useEffect(() => {
    // Function to update the height state
    const updateHeight = () => {
      if (summaryTextRef.current) {
        const newHeight = summaryTextRef.current.clientHeight

        setSummaryContainerHeight(newHeight)
      }
    }
    const updateContainerHeight = () => {
      if (summaryContainerHeightRef.current) {
        const newHeight = summaryContainerHeightRef.current.clientHeight

        setSummaryTextHeight(newHeight)
      }
    }

    // Initial height update
    updateContainerHeight()
    updateHeight()
  })

  // On click handler for link in AI answer
  const answerLinkClick = (linkProps) => {
    if (fptiData) {
      const options = {
        data: {
          page: fptiData.page,
          pgrp: fptiData.pgrp,
          name: 'gen_ai_summary',
          tag: 'ai-summary-link-clicked',
          link_name: 'ai-summary-link-clicked',
          link: linkProps.href,
          answerId,
          component: 'devdiscoverynodeweb',
          firstPageResult: true,
          searchID,
        },
      }

      if (window.PAYPAL?.analytics?.instance) {
        window.PAYPAL?.analytics?.instance?.recordClick(options)
      }
    }
  }
  const renderMarkDown = () => {
    return (
      <Markdown
        components={{
          a: ({ href, ...linkProps }) => (
            <Link
              className={styles.answerSummaryLink}
              onClick={() => answerLinkClick(linkProps)}
              href={`${href}?gen_ai_summary=true&search_id=${searchID}`}
              {...linkProps}
              target="_blank"
            />
          ),
        }}
      >
        {answerSummary}
      </Markdown>
    )
  }
  return (
    <div
      ref={summaryContainerHeightRef}
      className={`${styles.answerSummary} ${
        !collapseSeeMore ? undefined : styles.clampContainer
      }`}
    >
      <div ref={summaryTextRef}>{renderMarkDown()}</div>
    </div>
  )
}

export default MarkdownContainer
